import { useApiRequest } from "@hooks/use-api-request";
import { HttpMethod } from "@lib/http.helpers";
import { useMutation, useQueryClient } from "@tanstack/react-query";

export const useDeleteCareerMatches = (onSuccess) => {
  const queryClient = useQueryClient();
  const mutationFn = useApiRequest({
    url: "/users/me/careers",
    method: HttpMethod.Delete,
  });

  return useMutation({
    mutationKey: ["delete-career-matches"],
    mutationFn: () => mutationFn({}),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["career-matches"],
        // Wait to refetch career matches until requested. This will avoid
        // loading matches before the survey is complete.
        refetchType: "none",
      });
      queryClient.invalidateQueries({
        queryKey: ["user-career-ratings"],
        exact: true,
      });
      onSuccess?.();
    },
  });
};
